const ROAD_HOME_LIVE_EVENT_ID = "chi26-rockin-road-home-2026-09-26";
const HENDOS_EVENT_ID = "socal26-salute-social-temecula-2026-10-22";

const HOSTED_TICKET_EVENT_IDS = new Set([
  ROAD_HOME_LIVE_EVENT_ID,
  HENDOS_EVENT_ID,
]);

const EVENT_DETAILS = Object.freeze({
  [HENDOS_EVENT_ID]: Object.freeze({
    ticketHeading: "Hendo's Salute & Social Ticket",
    dateTime: "6:00–8:00 PM PT",
    venue: "Hendo's Barrel House",
    address: "27901 Jefferson Avenue, Temecula, CA 92590",
  }),
});

export function getHostedTicketEventDetails(eventId) {
  return EVENT_DETAILS[String(eventId || "")] || null;
}

export function isHostedTicketEvent(eventLike) {
  const eventId = String(eventLike?.event_id || eventLike?.id || eventLike || "").trim();
  return HOSTED_TICKET_EVENT_IDS.has(eventId);
}
